import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { setInputModuleByUnit } from 'actions/InputModule';
import ButtonContained from 'components/ButtonContained';
import Toggle from 'components/Toggle';
import LoadingIndicator from 'components/LoadingIndicator';

const isSameInputLine = (a, b) => a.moduleLockId === b.moduleLockId && a.inputSeq === b.inputSeq;

const DoorAlarmDetailModal = ({ uuDetail }) => {
    const dispatch = useDispatch();
    const [inputModuleByUnitDetails, setInputModuleByUnitDetails] = useState(uuDetail?.unit?.inputDevices);
    let isInAlarmState = false;

    if (uuDetail?.unit?.inputDevices?.length > 0) {
        isInAlarmState = uuDetail.unit.inputDevices.some((device) => device.inputDeviceState === 'Alarm');
    }

    useEffect(() => {
        setInputModuleByUnitDetails(uuDetail?.unit?.inputDevices);
    }, [uuDetail?.unit?.inputDevices]);

    const handleToggle = (module, enabled) => {
        const updatedModule = { ...module, inputDeviceEnabled: Number(enabled) };

        setInputModuleByUnitDetails((current) => current.map((m) => (isSameInputLine(m, module) ? updatedModule : m)));
        dispatch(
            setInputModuleByUnit(
                {
                    moduleLines: [updatedModule]
                },
                {
                    successMessage: 'Alarm status updated successfully',
                    errorMessage: 'Failed to update alarm status'
                }
            )
        );
    };

    const handleDismissAlarm = () => {
        dispatch(
            setInputModuleByUnit(
                {
                    moduleLines: inputModuleByUnitDetails,
                    dismissAlarm: true
                },
                {
                    successMessage: 'Alarm(s) dismissed successfully',
                    errorMessage: 'Failed to dismiss alarm(s)'
                }
            )
        );
    };

    return (
        <div className="px-10 pt-4">
            {inputModuleByUnitDetails ? (
                <>
                    <div className="min-h-75 max-h-[50vh] overflow-y-auto custom-scrollbar">
                        <table>
                            <thead>
                                <tr>
                                    <th className="px-4 py-2">Input Module</th>
                                    <th className="px-4 py-2">Alarm Status</th>
                                    <th className="px-4 py-2">Door Status</th>
                                    <th className="px-4 py-2">Alarm Enabled</th>
                                </tr>
                            </thead>
                            <tbody>
                                {inputModuleByUnitDetails.map((module) => (
                                    <tr key={`${module.moduleLockId}-${module.inputSeq}`}>
                                        <td className="px-4 py-2">{module.moduleLockName}</td>
                                        <td className="px-4 py-2">{module.inputDeviceState}</td>
                                        <td className="px-4 py-2">{module.inputDeviceDoorStatus}</td>
                                        <td className="px-4 py-2">
                                            <Toggle
                                                checked={module.inputDeviceEnabled}
                                                size="small"
                                                onChange={(enabled) => handleToggle(module, enabled)}
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {isInAlarmState && (
                        <div className="mt-4">
                            <ButtonContained
                                id="Door-Alarm-Dismiss-Button"
                                dataCy="Door-Alarm-Dismiss-Button"
                                text={uuDetail?.unit?.inputDevices?.length === 1 ? 'Dismiss Alarm' : 'Dismiss Alarm - All'}
                                type="default"
                                overrideColor="bg-[var(--color-alert)]"
                                onClick={() => handleDismissAlarm()}
                            />
                        </div>
                    )}
                </>
            ) : (
                <div className="flex justify-center items-center h-full">
                    <LoadingIndicator />
                </div>
            )}
        </div>
    );
};

export default DoorAlarmDetailModal;
